import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { SpecialtyEntity } from './specialty.entity';

@Index('client_specialty__fk_specialty__id_fk', ['fkSpecialtyId'], {})
@Index('client_specialty_pk', ['fkClientId', 'fkSpecialtyId'], { unique: true })
@Entity('client_specialty')
export class ClientSpecialtyEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: '_fk_specialty__id', unsigned: true })
	public fkSpecialtyId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientSpecialties, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(
		() => SpecialtyEntity,
		(specialty) => specialty.clientSpecialties,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_specialty__id', referencedColumnName: 'id' }])
	public fkSpecialty!: SpecialtyEntity;
}
